import client from './client';

export const supplementsApi = {
  // Supplement database
  getAll: (params) => client.get('/supplements', { params }),
  getById: (id) => client.get(`/supplements/${id}`),
  create: (data) => client.post('/supplements', data),
  update: (id, data) => client.put(`/supplements/${id}`, data),
  delete: (id) => client.delete(`/supplements/${id}`),

  // Client supplement plans (coach assigns)
  getClientPlan: (clientId) =>
    client.get('/supplements/plan', { params: { client_id: clientId } }),
  assignSupplement: (data) => client.post('/supplements/plan', data),
  updateAssignment: (id, data) => client.put(`/supplements/plan/${id}`, data),
  removeAssignment: (id) => client.delete(`/supplements/plan/${id}`),

  // Supplement plan version history + Trash (/supplement-plans, not /supplements/plan)
  listPlanVersions: (id) => client.get(`/supplement-plans/${id}/versions`),
  getPlanVersion: (id, n) => client.get(`/supplement-plans/${id}/versions/${n}`),
  restorePlanVersion: (id, n) => client.post(`/supplement-plans/${id}/versions/${n}/restore`),
  listDeletedPlans: () => client.get('/supplement-plans/deleted'),
  restoreDeletedPlan: (id) => client.post(`/supplement-plans/deleted/${id}/restore`),

  // Daily check-off (client)
  getTodayLog: (params) => client.get('/supplements/log/today', { params }),
  checkOff: (data) => client.post('/supplements/log', data),
  getAdherence: (params) => client.get('/supplements/adherence', { params }),
};
